import React, { useState } from "react";
import { Box, Typography, Button, Container, TextField, CircularProgress, Grid, Modal } from "@mui/material";
import axios from "axios";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FaRegCircleCheck } from "react-icons/fa6";




export const ContactoInicio = () => {
  const backendURL = process.env.REACT_APP_BACKEND_URL;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successAlertOpen, setSuccessAlertOpen] = useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = useState(false);
  const [enviandoAlert, setenviandoAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [formData, setFormData] = useState({
    nombre: "",
    empresa: "",
    correo: "",
    telefono: "+56",
    mensaje: "",
  });

 const handleChanges = (e) => {
  const { name, value } = e.target;

  if (name === "telefono") {
    // Siempre forzar que empiece con +56 y solo permitir números después
    let newValue = value;

    if (!newValue.startsWith("+56")) {
      newValue = "+56" + newValue.replace(/[^\d]/g, "");
    } else {
      newValue = "+56" + newValue.slice(3).replace(/[^\d]/g, ""); // solo números después de +56
    }

    setFormData({ ...formData, telefono: newValue });
  } else {
    setFormData({ ...formData, [name]: value });
  }
};
  const isValidEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

const isValidPhone = (phone) => {
  const regex = /^\+?\d{7,15}$/; // acepta desde 7 hasta 15 dígitos con o sin +
  return regex.test(phone);
};
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setenviandoAlert(true);

    if (!isValidEmail(formData.correo)) {
      setIsSubmitting(false);
      setenviandoAlert(false);
      setAlertMessage("Formato de correo electrónico inválido");
      setErrorAlertOpen(true);
      return;
    }

    if (!isValidPhone(formData.telefono)) {
      setIsSubmitting(false);
      setenviandoAlert(false);
      setAlertMessage("Formato de teléfono inválido. Usa solo números y opcional '+'");
      setErrorAlertOpen(true);
      return;
    }
    try {
      const response = await axios.post(
        `${backendURL}/api/cotizacion`, // Ruta del backend
        formData, // Datos enviados en el cuerpo de la solicitud
        {
          headers: {
            "Content-Type": "application/json", // Asegúrate de usar el tipo de contenido correcto
          },
        }
      );

      // Si la respuesta es exitosa
      if (response.status === 200 || response.status === 201) {
        setIsSubmitting(false);
        setenviandoAlert(false);
        setSuccessAlertOpen(true);
        setAlertMessage("Mensaje enviado correctamente")
        setFormData({
  nombre: "",
  empresa: "",
  correo: "",
  telefono: "",
  mensaje: "",
});
 setTimeout(() => {
    setSuccessAlertOpen(false);
  }, 3000);
      }
    } catch (err) {
      // Captura errores del backend
      if (err.response && err.response.data.errors) {
        const backendErrors = Object.values(err.response.data.errors)
          .flat()
          .join(", ");
            setenviandoAlert(false);
        setIsSubmitting(false);
        setAlertMessage(backendErrors);
        setErrorAlertOpen(true);

      } else {
          setenviandoAlert(false);
        setIsSubmitting(false);
        setAlertMessage(err.message || "Error desconocido al enviar el formulario");
        setErrorAlertOpen(true);
      }
    } finally {
         setenviandoAlert(false);
    }
  };

  return (

    <Container maxWidth='md' sx={{  marginTop: '200px', marginBottom: '100px' }} >
      <Box
        sx={{ marginBottom: '60px' }}
      >
        <Typography variant="h4" align="center" gutterBottom sx={{
          fontFamily: 'Montserrat', fontWeight: '400', color: '#1A425B', textTransform: 'uppercase', '@media (max-width: 750px)': {
            fontSize: "1.3rem",

          },
        }}>
          <strong>cotiza</strong> aquí
        </Typography>
        <Typography variant="h6" align="center" gutterBottom sx={{
          fontFamily: 'Montserrat', fontWeight: '500', color: '#1A425B', '@media (max-width: 750px)': {
            fontSize: "1rem",

          },
        }}>
          Contáctanos y llevemos tu negocio al siguiente nivel
        </Typography>
      </Box>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={4} sx={{'@media (max-width: 599px)': {flexDirection:'column'}}}>
          <Grid size={{ sm: 12, md: 6 }}>
            <div >
              <label htmlFor="mensaje" style={labelcontacto}>Nombre</label>
              <TextField
                sx={inputStyle}
                name="nombre"
                value={formData.nombre}
                onChange={handleChanges}
                fullWidth
                required
              />

            </div>
          </Grid>
          <Grid size={{ sm: 12, md: 6 }}>
            <div>
              <label htmlFor="mensaje" style={labelcontacto}>Empresa</label>
              <TextField
                sx={inputStyle}
                name="empresa"
                value={formData.empresa}
                onChange={handleChanges}
                fullWidth
                required
              />

            </div>
          </Grid>
          <Grid size={{ sm: 12, md: 7 }}>
            <div >
              <label htmlFor="mensaje" style={labelcontacto}>Correo electrónico</label>
              <TextField
                sx={inputStyle}
                name="correo"
                value={formData.correo}
                onChange={handleChanges}
                fullWidth
                required
              />

            </div>
          </Grid>
          <Grid size={{ sm: 12, md: 5 }}>
            <div>
              <label htmlFor="mensaje" style={labelcontacto}> Teléfono de contacto</label>
              <TextField
                sx={inputStyle}

                name="telefono"
                value={formData.telefono}
                onChange={handleChanges}
                fullWidth
                required
                 inputProps={{
                  inputMode: 'tel',
                  maxLength: 12, // +56 9XXXXXXX = 12 chars
                }}
              />

            </div>
          </Grid>
          <Grid size={{ sm: 12, md: 12 }}>
            <label htmlFor="mensaje" style={labelcontacto}>Mensaje</label>
            <TextField
              sx={inputmensajeStyle}
              name="mensaje"
              value={formData.mensaje}
              onChange={handleChanges}
              multiline
              rows={4}
              fullWidth
              required
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ marginTop: '40px' }}>
          {isSubmitting ? (
            <CircularProgress />
          ) : (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ px: 4, fontSize: '1rem', fontFamily: 'Montserrat', textTransform: 'capitalize', background: ' #00A69E', borderRadius: '50PX' }}
            >
              Enviar cotización
            </Button>
          )}

        </Box>
      </form>





      <Modal open={successAlertOpen} >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        >

          <section style={{ textAlign: 'center' }}>
            <FaRegCircleCheck style={{ color: 'green', fontSize: '2rem', marginBottom: '1rem' }} />
            <p style={{ fontFamily: 'Montserrat', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: "-5px" }}>
              {alertMessage}
            </p>
          </section>
        </Box>
      </Modal>

      {/* Popup de error */}

      <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)} >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        
        >

          <section style={{ textAlign: 'center' }}>
          <FaRegCircleXmark style={{ color: 'red', fontSize: '2rem', marginBottom: '1rem' }} />
            <p style={{ fontFamily: 'Montserrat', color: '#585857', fontSize: '0.8rem', fontWeight: '600', marginTop: "-5px" }}>
              {alertMessage}
            </p>
          </section>
        </Box>
      </Modal>
      {/* Popup de carga */}
      <Modal open={enviandoAlert} onClose={() => setenviandoAlert(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '350px',
            height: 'auto',
            bgcolor: '#ffff',
            boxShadow: 24,
            p: 1,
            borderRadius: '10px',
            '@media (max-width: 500px)': {
              width: '90%',
            },
          }}
        
        >
          <section style={{ textAlign: 'center', padding: '1rem' }}>
            <CircularProgress style={{ color: '#1A425B1' }} />
            <p style={{ fontFamily: 'Montserrat', color: ' #1A425B', fontSize: '0.8rem', fontWeight: '600', marginTop: '20px' }}>
              Procesando solicitud...
            </p>
          </section>
        </Box>
      </Modal>

    </Container>


  )
}



// Estilos reutilizables
const inputStyle = {
  background: "#fff",
  marginTop:'10px',
  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "50px", // Aquí se aplica el borde redondeado
    "& fieldset": {
      borderColor: "#1A425B",
    },
    "&:hover fieldset": {
      borderColor: "#1A425B",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1A425B",
    },
  },
  "& .MuiInputLabel-root": {
    fontFamily: "Montserrat",
    color: "#1A425B",
  },
  "& .MuiInputBase-input": {
    fontFamily: "Montserrat",
    color: "#1A425B",
  },
};

// Estilos reutilizables
const inputmensajeStyle = {
   marginTop:'10px',
  background: "#fff",
  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "20px", // Aquí se aplica el borde redondeado
    "& fieldset": {
      borderColor: "#1A425B",
    },
    "&:hover fieldset": {
      borderColor: "#1A425B",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1A425B",
    },
  },
  "& .MuiInputLabel-root": {
    fontFamily: "Montserrat",
    color: "#1A425B",
  },
  "& .MuiInputBase-input": {
    fontFamily: "Montserrat",
    color: "#1A425B",
  },
};

const labelcontacto = {
  color: "#1A425B",
  marginLeft: '25px',

}